<script setup lang="ts">
import { computed } from 'vue'
import type { RenderStats } from '@/composables/useRenderLoop'

const props = defineProps<{
  stats: RenderStats
  meshCount: number
  visibleMeshCount: number
}>()

const lines = computed(() => [
  `${props.stats.fps.toFixed(0)} fps  ${props.stats.frameMs.toFixed(1)} ms`,
  `${props.stats.drawCalls} draws  ${(props.stats.triangles / 1000).toFixed(0)}k tris`,
  `${props.meshCount} meshes  ${props.visibleMeshCount} visible`,
])
</script>

<template>
  <div class="viewer-stats">
    <div v-for="line in lines" :key="line">{{ line }}</div>
  </div>
</template>

<style scoped>
.viewer-stats {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.65);
  color: #7fffa0;
  border-radius: 4px;
  font-family: monospace;
  font-size: 11px;
  line-height: 1.45;
  white-space: pre;
  pointer-events: none;
  z-index: 3;
}
</style>
